import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { MuiThemeProvider } from '@material-ui/core/styles';
import '../../styling/Styles.css';
import '../../styling/SpinnerStyle.css';
import { Beforeunload } from 'react-beforeunload';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import { muiTheme } from '../../styling/Styles';
import AuthContext from '../AppAuthContext';
import PagesFunctionsBar from './PagesFunctionsBar/PagesFunctionsBar';
import TableManager from './TableManager';
import apiService from '../../services/apiService';
import LoadEditableElements from './Events/LoadEditableElements';
import EditElements from './GrapesJs/EditElements/EditElements';
import BuildAppsBreadcrumb from './Breadcrumb/BuildAppsBreadcrumb';
import { nameExists, nameNull } from '../../validations/validations';
import { loadUIelements, saveUIelements, clearUIelements } from './handleStoreElements';
import { renderServiceBlocks, renderDataElementsBlocks, renderCustomBlocks } from './renderCreatedBlocks';
import ExportBackendSpinner from './Spinners/ExportBackendSpinner';
import ExportFrontSdk from './Spinners/ExportFrontSdk';
import SyncToGithub from './Spinners/SyncToGithub';

import initGrapes from './GrapesJs/InitGrapes';
import LoadJavascript from './Spinners/LoadJavascript';

const BuildApps = () => {
  const [projectNamesPages, setProjectNamesPages] = React.useState('');
  const [savedPagesPerProject, setSavedPagesPerProject] = React.useState('');
  const { state, dispatch } = useContext(AuthContext);
  const [selectedProject, setSelectedProject] = React.useState(-1);
  const [selectedPage, setSelectedPage] = React.useState(-1);
  const [renderGrape, setRenderGrape] = React.useState(false);
  const [loadInfo, setLoadInfo] = React.useState(false);
  const [servicesBlocks, setServicesBlocks] = React.useState();
  const [servicesRequests, setServicesRequests] = React.useState();
  const location = useLocation();
  const [triggeredButtonFlow, setTriggeredButtonFlow] = React.useState(false);
  const [indexPageFlow, setIndexPageFlow] = React.useState(false);
  const [editor, setEditor] = React.useState('');
  const [displaySpinner, setDisplaySpinner] = React.useState(false);
  const [displayProjectSpinner, setDisplayProjectSpinner] = React.useState(true);
  const [displayExportBackendSpinner, setDisplayExportBackendSpinner] = React.useState(false);
  const [displayExportFrontSdkSpinner, setDisplayExportFrontSdkSpinner] = React.useState(false);
  const [displaySyncToGithubSpinner, setDisplaySyncToGithubSpinner] = React.useState(false);
  const [displayWentWrongUi, setDisplayWentWrongUi] = React.useState(false);
  const [lockLoadInfo, setLockLoadInfo] = React.useState(true);
  const [loadSpinnerCreateJavascript, setLoadSpinnerCreateJavascript] = React.useState(false);
  const [runFullScreen, setRunFullScreen] = React.useState(false);
  const [anchorApplyStylingEl, setAnchorApplyStylingEl] = React.useState(null);
  const [enableBreadCrumb, setEnableBreadcrumb] = React.useState(true);
  const navigate = useNavigate();

  // these are the new states for the refactored build apps
  const [project, setProject] = React.useState({});

  /**
   * This useEffect will populate the project's pages
   *
   */
  useEffect(() => {
    //  escapes when there is no selection
    if(!location.state){
      navigate('/'); // this will redirect to the home page
      return;
    }
    if (selectedProject === -1) return undefined;
    const projects = JSON.parse(localStorage.getItem('data'));
    const projectToDownload = projects[selectedProject];
    if (projectToDownload.pages.length === 0) {
      setDisplayProjectSpinner(false);
      return undefined;
    }

    // escapes first time that we go back to build apps and we dont want to reload page info.
    if (location.state.reason !== undefined && lockLoadInfo === true) {
      setLockLoadInfo(false);
      setDisplayProjectSpinner(false);
      return 1;
    }

    Promise.all(
      projectToDownload.pages.map((pageToDownload) =>
        //  the code bellow might seems strange but it formats for the first time the page id
        apiService.readPage({
          pageId: (pageToDownload.pageId && pageToDownload.pageId) || pageToDownload
        })
      )
    )
      .then((responses) => responses.map((response) => response))
      .then((pages) => {
        projectToDownload.pages = pages;
        return projectToDownload;
      })
      .then((updatedProject) => {
        projects[selectedProject] = updatedProject;
        setProject({ ...updatedProject });
        return projects;
      })
      .then((updatedProjects) => {
        updatedProjects.forEach((proj, index) => {
          if (index !== selectedProject) {
            proj.pages.forEach((page, index2) => {
              if (page.pageId !== undefined) {
                updatedProjects[index].pages[index2] = page.pageId;
              }
            });
          }
        });
        localStorage.setItem('data', JSON.stringify(updatedProjects));
        setDisplayProjectSpinner(false);
        loadUIelements(editor, selectedPage, selectedProject);
        editor.stopCommand('enable-navigate-page');
        setLoadInfo(true);
      })
      .catch((error) => {
        setDisplayProjectSpinner(false);
        throw error;
      });

    return 1;
    
  }, [selectedProject]);

  //  Fetching the project unpopulated when changing pages inside a project and sets project
  //  this should update local storage project
  useEffect(() => {
    if (selectedProject === -1) return;
    const projects = JSON.parse(localStorage.getItem('data'));
    const projectFromStorage = projects[selectedProject];
    apiService
      .readProject(projectFromStorage._id, {})
      .then((response) => {
        setProject(response.data);
        return response.data;
      })
      .then((updatedProject) => {
        Object.keys(projectFromStorage).forEach((key) => {
          if (key !== 'pages') projectFromStorage[key] = updatedProject[key];
        });
        // This means that the initial load has not been made
        if (projectFromStorage?.pages?.[0] && typeof projectFromStorage.pages[0] !== 'object')
          return;
        projects[selectedProject] = projectFromStorage;
        localStorage.setItem('data', JSON.stringify(projects));
      })
      .catch((error) => {
        if (error.message === 'authentication failed') {
          dispatch({ type: 'LOGOUT' });
        }
      });
  }, [selectedPage]);

  // TODO:   here the project would be updated and stored todo here I should continue
  // TODO:  when you delete a page the project state should have less pagesId
  useEffect(() => {
    if (selectedProject === -1 || Object.keys(project).length === 0) return;
    const projects = JSON.parse(localStorage.getItem('data'));
    const projectFromStorage = projects !== null ? projects[selectedProject] : {};
    if (projectFromStorage.pages.length === project.pages.length || !projectFromStorage.pages)
      return;
    const storedPagesId = projectFromStorage.pages.map((singlePage) => singlePage.pageId);
    const newPages = project.pages.filter((pageId) => !storedPagesId.includes(pageId));

    Promise.all(
      newPages.map((pageToDownload) =>
        //  the code bellow might seems strange but it formats for the first time the page id
        apiService.readPage({
          pageId: (pageToDownload.pageId && pageToDownload.pageId) || pageToDownload
        })
      )
    )
      .then((responses) => responses.map((response) => response))
      .then((pages) => {
        projectFromStorage.pages = projectFromStorage.pages.concat(pages);
        return projectFromStorage;
      })
      .then((updatedProject) => {
        projects[selectedProject] = updatedProject;
        return projects;
      })
      .then((updatedProjects) => localStorage.setItem('data', JSON.stringify(updatedProjects)))
      .then(() => {
        setLoadInfo(true);
      })
      .catch((error) => {throw(error)});
  }, [project]);
  // here it needs a useEffect to check if the pages has been changed if they have
  // there should be a new request to get them again and init once

  // //  This loads a new page when the user change a page inside a project
  useEffect(() => {
    //  check if the project is empty only keys is needed
    if (Object.keys(project).length === 0) return;
    if (selectedPage === -1) return;
    if (project.pages[selectedPage] === undefined) return;
    const pageId = project.pages[selectedPage].pageId || project.pages[selectedPage];
    const pageFromStorage = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[
      selectedPage
    ];
    apiService
      .latestPageTimestamp(pageId)
      .then(async ({ data }) => {
        if (data.timestamp === pageFromStorage.timestamp) return pageFromStorage;
        return apiService.readPage({ pageId });
      })
      .catch((error) => {
        if (error.message === 'authentication failed') {
          dispatch({ type: 'LOGOUT' });
        }
      });
  }, [selectedPage, project]);

  useEffect(() => {
    let selectedProjectIndex = -1;
    const projectsFromStorage = JSON.parse(localStorage.getItem('data'));
    if (!projectsFromStorage) return;
    if (!location.state) return;

    // this set the selectedProjectIndex should be made using filter
    // TODO: refactor using filter

    projectsFromStorage.forEach((item, index1) => {
      if (item.name === location.state.name) {
        selectedProjectIndex = index1;
      }
    });

    if (editor !== undefined && editor.BlockManager !== undefined) {
      clearUIelements(editor);
      if (projectsFromStorage[selectedProjectIndex].pages.length > 0) setSelectedPage(0);
      editor.runCommand('enable-navigate-page');
      loadUIelements(editor, 0, selectedProjectIndex);
      renderServiceBlocks(editor, selectedProjectIndex);
      renderDataElementsBlocks(editor, selectedProjectIndex);
      renderCustomBlocks(editor,selectedProjectIndex);
      setSelectedProject(selectedProjectIndex);
    }
  }, [renderGrape]);

  // this useEffect will store the services to local storage
  useEffect(() => {
    const projects = JSON.parse(localStorage.getItem('data')) || [];
    if (!project || Object.keys(project).length === 0) return;
    projects.forEach((projectFromStorage) => {
      if (!projectFromStorage.services[0])
        projectFromStorage.services.push({ services_blocks: [], services_requests: [] });
    });
    localStorage.setItem('data', JSON.stringify(projects));
  }, [loadInfo]);

  // this useEffect will populate data elemenent and store it to local storage
  useEffect(() => {
    const projects = JSON.parse(localStorage.getItem('data')) || [];
    projects.forEach((projectFromStorage) => {
      if (!projectFromStorage.data_elements)
        projectFromStorage.services.data_elements = {
          data_elements_blocks: [],
          data_elements_info: []
        };
    });
    localStorage.setItem('data', JSON.stringify(projects));
  }, [loadInfo]);

  // this useEffect hopefully will populate the names
  useEffect(() => {
    let projectsPagesNames = [];
    const projects = JSON.parse(localStorage.getItem('data')) || [];
    // this creates the double array
    projectsPagesNames = projects.map((projectFromStorage) =>
      projectFromStorage.pages.map((pageFromStorage) => pageFromStorage.name)
    );
    setProjectNamesPages(projectsPagesNames);
  }, [loadInfo]);

  // this useEffect will populate projectsPagesSaved
  useEffect(() => {
    let projectsPagesSaved = [];
    const projects = JSON.parse(localStorage.getItem('data')) || [];
    // this creates the double array
    projectsPagesSaved = projects.map((projectFromStorage) =>
      new Array(projectFromStorage.pages.length).fill(true)
    );
    setSavedPagesPerProject(projectsPagesSaved);
  }, [loadInfo]);

  // this useEffect will populate servicesBlocks
  useEffect(() => {
    const projects = JSON.parse(localStorage.getItem('data')) || [];
    // debugger;
    setServicesBlocks(
      projects.map((projectFromStorage) => projectFromStorage.services[0]?.services_blocks || []) ||
        []
    );
  }, [loadInfo]);

  // this useEffect will populate servicesRequests
  useEffect(() => {
    const projects = JSON.parse(localStorage.getItem('data')) || [];
    setServicesRequests(
      projects.map(
        (projectFromStorage) => projectFromStorage.services[0]?.services_requests || []
      ) || []
    );
  }, [loadInfo]);

  useEffect(() => {
    if (loadInfo === true) {
      setLoadInfo(false);
    }
  }, [loadInfo]);

  useEffect(() => {
    localStorage.setItem('selectedPage', selectedPage);
    localStorage.setItem('selectedProject', selectedProject);
  }, [selectedPage, selectedProject]);

  const savedPageClicked = async () => {

    if (
      nameExists(selectedPage, selectedProject) ||
      nameNull(selectedPage, selectedProject) ||
      selectedPage < 0
    )
      return;

    /* Components selectedPage gets updated without updating the localStorage,
      * This shouldnt be happening 
      * TODO: look it up
    */
    editor.DomComponents.store();
    saveUIelements(editor, localStorage.getItem('selectedPage'), selectedProject);

    const tempData = JSON.parse(localStorage.getItem('data'));
    if (tempData !== undefined && tempData[selectedProject] !== undefined) {
      tempData[selectedProject].pages[selectedPage].name =
        projectNamesPages[selectedProject][selectedPage];
      localStorage.setItem('data', JSON.stringify(tempData));
    }

    const temp = [...savedPagesPerProject];
    temp[selectedProject][selectedPage] = true;
    setSavedPagesPerProject(temp);
    /**
     *  here the next steps should be implemente
     *  TODO: a project has some fields that are cross pages. Therefore a new request should
     *  be made to get the projects fields. The field should somehow merged
     *  here the updated project should be stored to local storage
     */

    apiService
      .updatePage(tempData[selectedProject].pages[selectedPage])
      .then(() => apiService.readProject(tempData[selectedProject]._id, {}))
      .then((response) => {
        const { annotations, data_elements, services, customBlocks } = tempData[selectedProject];

        return apiService.updateProject2(response.data._id, {
          annotations,
          data_elements,
          services,
          customBlocks,
          date: (new Date().toLocaleString("en-GB")).toString()
        });
      })
      .catch((error) => {throw error;});

  };

  useEffect(() => {
    if (triggeredButtonFlow === true) {
      setTriggeredButtonFlow(false);

      if (indexPageFlow > -1) {
        const tempSelectedPage = parseInt(localStorage.getItem('selectedPage'), 10);
        const tempSelectedProject = parseInt(localStorage.getItem('selectedProject'), 10);
        setSelectedPage(indexPageFlow);
        saveUIelements(editor, tempSelectedPage, tempSelectedProject,dispatch);
        clearUIelements(editor);
        loadUIelements(editor, indexPageFlow, tempSelectedProject);
      }
    }
  });

  useEffect(() => {
    if (renderGrape === false) {
      initGrapes(setEditor, setTriggeredButtonFlow, setIndexPageFlow,setLoadSpinnerCreateJavascript,setAnchorApplyStylingEl);
      setRenderGrape(true);
    }
  }, [renderGrape]);

  if (!state.isLoggedIn) return <Navigate to="/login" />;

  return (
    <div className={clsx('generalFlex')}>
      {displayProjectSpinner === true && (
        <div
          style={
            displayProjectSpinner === false
              ? { display: 'none' }
              : { display: 'flex', justifyContent: 'center' }
          }
          id="cover-spin-project"
        >
          <span style={{ position: 'absolute', top: '40%', fontSize: '1.2rem', color: '#0c4d82' }}>
            {' '}
            Please wait for project to load info of pages ...
          </span>
        </div>
      )}
      {runFullScreen !== true ? (
        <div className={clsx('flexProps2')}>
          <WabliAppBar
            isBuildApp
            savedPagesPerProject={savedPagesPerProject}
            projectNamesPages={projectNamesPages}
            savedPageClicked={savedPageClicked}
            selectedProject={selectedProject}
            selectedPage={selectedPage}
          />
          <BuildAppsBreadcrumb
            selectedPage={selectedPage}
            selectedProject={selectedProject}
            savedPagesPerProject={savedPagesPerProject}
            setSavedPagesPerProject={setSavedPagesPerProject}
            setSelectedProject={setSelectedProject}
            setSelectedPage={setSelectedPage}
            editor={editor}
            projectNamesPages={projectNamesPages}
            setProjectNamesPages={setProjectNamesPages}
            savedPageClicked={savedPageClicked}
            displaySpinner={displaySpinner}
            setDisplaySpinner={setDisplaySpinner}
            setDisplayProjectSpinner={setDisplayProjectSpinner}
            setDisplayExportBackendSpinner={setDisplayExportBackendSpinner}
            setDisplayExportFrontSdkSpinner={setDisplayExportFrontSdkSpinner}
            setDisplaySyncToGithubSpinner={setDisplaySyncToGithubSpinner}
            setDisplayWentWrongUi={setDisplayWentWrongUi}
            enableBreadCrumb={enableBreadCrumb}
          />
        </div>
      ) : null}

      <div className={clsx('flexRowDirection', 'overflowHidden')} style={{flex: "1 0 80%"}} >
        <div
          className={clsx('flexProsLeftPanel', 'blueLabel2', 'tabPanel')}
          style={{ display: 'inherit' }}
        >
          <TableManager
            selectedPage={selectedPage}
            selectedProject={selectedProject}
            editor={editor}
            savedPageClicked={savedPageClicked}
            servicesBlocks={servicesBlocks}
            setServicesBlocks={setServicesBlocks}
            servicesRequests={servicesRequests}
            setServicesRequests={setServicesRequests}
          />
        </div>

        <div className={clsx('flexProps2')} style={{ width: '100%' }}>
          <MuiThemeProvider theme={muiTheme}>
            <PagesFunctionsBar
              savedPageClicked={savedPageClicked}
              selectedProject={selectedProject}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
              editor={editor}
              projectNamesPages={projectNamesPages}
              setProjectNamesPages={setProjectNamesPages}
              savedPagesPerProject={savedPagesPerProject}
              setSavedPagesPerProject={setSavedPagesPerProject}
              setProject={setProject}
              anchorApplyStylingEl={anchorApplyStylingEl}
              setAnchorApplyStylingEl={setAnchorApplyStylingEl}
            />
          </MuiThemeProvider>
          <div
            className={clsx('editor1-row')}
            id="editor1"
            style={{ flex: '1 0 90%', alignSelf: 'stretch' }}
          >
            {displaySpinner === true && <div id="cover-spin"> </div>}
            <div id="gjs" style={selectedPage < 0 ? { display: 'none' } : null}>
              {' '}
            </div>
            <div
              className={clsx('emptyEditor', 'red')}
              style={selectedPage >= 0 ? { display: 'none' } : null}
            >
              <span className={clsx('emptyEditorText')}>No page has been selected</span>
            </div>
          </div>
        </div>
      </div>
      <Beforeunload onBeforeunload={(event) => event.preventDefault()} />
      <EditElements
        editor={editor}
        selectedPage={selectedPage}
        selectedProject={selectedProject}
        savedPageClicked={savedPageClicked}
      />
      <LoadEditableElements
        editor={editor}
        selectedPage={selectedPage}
        selectedProject={selectedProject}
        setDisplaySpinner={setDisplaySpinner}
        setRunFullScreen={setRunFullScreen}
        loadInfo={loadInfo}
        savedPagesPerProject={savedPagesPerProject}
        setSavedPagesPerProject={setSavedPagesPerProject}
        setEnableBreadcrumb={setEnableBreadcrumb}
        savedPageClicked={savedPageClicked}
      />

      <ExportBackendSpinner
        displayExportBackendSpinner={displayExportBackendSpinner}
        displayWentWrongUi={displayWentWrongUi}
        setDisplayWentWrongUi={setDisplayWentWrongUi}
      />
      <ExportFrontSdk
        displayExportFrontSdkSpinner={displayExportFrontSdkSpinner}
        displayWentWrongUi={displayWentWrongUi}
        setDisplayWentWrongUi={setDisplayWentWrongUi}
      />
      <SyncToGithub
        displaySyncToGithubSpinner={displaySyncToGithubSpinner}
        displayWentWrongUi={displayWentWrongUi}
        setDisplayWentWrongUi={setDisplayWentWrongUi}
      />
      <LoadJavascript
        loadSpinnerCreateJavascript={loadSpinnerCreateJavascript}
      />
    </div>
  );
};

export default BuildApps;
